"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.cognitoUserPoolTransferHandler = void 0;
const core_1 = require("@aws-amplify/core");
const composers_1 = require("@aws-amplify/core/internals/aws-client-utils/composers");
const aws_client_utils_1 = require("@aws-amplify/core/internals/aws-client-utils");
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */
const disableCacheMiddlewareFactory = () => (next, _) => async function disableCacheMiddleware(request) {
    // Read any custom Auth headers off the global AmplifyContext's library
    // options. Guarded with `hasGlobalContext()` because this handler can run
    // in edge paths BEFORE `Amplify.configure()` — an unconfigured state must
    // degrade to no custom headers (preserving the previous
    // `Amplify.libraryOptions?.Auth?.headers?.()` no-op behavior), NOT throw.
    const customHeaders = (0, core_1.hasGlobalContext)()
        ? await (0, core_1.getGlobalContext)().libraryOptions?.Auth?.headers?.()
        : undefined;
    request.headers = {
        ...request.headers,
        'cache-control': 'no-store',
        ...customHeaders,
    };
    return next(request);
};
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */
exports.cognitoUserPoolTransferHandler = (0, composers_1.composeTransferHandler)(aws_client_utils_1.unauthenticatedHandler, [disableCacheMiddlewareFactory]);
